<template>
    <transition
        :css="false"
        @enter="intro"
        @leave="outro"
    >
        <div class="Carousel">
            <div
                v-if="backIndex !== null"
                ref="slideBack"
                class="Carousel-slide"
                :style="backSlideStyle"
            ></div>
            <div
                v-if="frontIndex !== null"
                ref="slideFront"
                class="Carousel-slide"
                :style="frontSlideStyle"
            ></div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'Carousel',
    props: {
        imagesSrc: {
            type: Array,
            required: true,
        },
        activeItem: {
            type: Number,
            default: 0,
        },
        introDisabled: {
            type: Boolean,
            default: false,
        },
        introDuration: {
            type: Number,
            default: 1,
        },
        introDelay: {
            type: Number,
            default: 0,
        },
        introEase: {
            type: Object,
            default: () => Quart.easeIn,
        },
        outroDisabled: {
            type: Boolean,
            default: false,
        },
        outroDuration: {
            type: Number,
            default: 1,
        },
        outroDelay: {
            type: Number,
            default: 0,
        },
        outroEase: {
            type: Object,
            default: () => Quart.easeOut,
        },
        slideFadeDuration: {
            type: Number,
            default: 1,
        },
        slideFadeDelay: {
            type: Number,
            default: 0,
        },
        slideFadeEase: {
            type: Object,
            default: () => Quart.easeOut,
        },
    },
    data: () => ({
        backIndex: null,
        frontIndex: null,
    }),
    methods: {
        intro(el, done) {
            this.backIndex = this.activeItem
            this.frontIndex = this.activeItem
            if (this.introDisabled) {
                done()
            } else {
                TweenLite.fromTo(el, this.introDuration, {
                    alpha: 0,
                }, {
                    alpha: 1,
                    delay: this.introDelay,
                    ease: this.introEase,
                    onComplete: done,
                })
            }
        },
        outro(el, done) {
            if (this.outroDisabled) {
                done()
            } else {
                TweenLite.to(el, this.outroDuration, {
                    alpha: 0,
                    delay: this.outroDelay,
                    ease: this.outroEase,
                    onComplete: done,
                    overwrite: 'all',
                })
            }
        },
        changeSlide() {
            const { $refs } = this
            TweenLite.fromTo($refs.slideFront, this.slideFadeDuration, {
                alpha: 0,
            }, {
                alpha: 1,
                ease: this.slideFadeEase,
                delay: this.slideFadeDelay,
                onComplete: () => {
                    this.backIndex = this.frontIndex
                },
            })
        },
    },
    computed: {
        backSlideStyle() {
            const { backIndex, imagesSrc } = this
            return {
                'background-image': `url(${imagesSrc[backIndex]})`,
            }
        },
        frontSlideStyle() {
            const { frontIndex, imagesSrc } = this
            return {
                'background-image': `url(${imagesSrc[frontIndex]})`,
            }
        },
    },
    watch: {
        activeItem(val) {
            this.backIndex = this.frontIndex
            this.frontIndex = val
            this.$nextTick(this.changeSlide)
        },
    },
}
</script>

<style src="styles/components/Carousel.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/Carousel.vue